<script setup lang="ts">
  import { useRoute, useRouter } from "vue-router"
  import { Button } from "@/components/ui/button"
  import Icon from "@/components/ui/icons/Icon.vue"

  const { title } = defineProps<{
    title: string
  }>()

  const router = useRouter()
  const route = useRoute()
</script>

<template>
  <div class="relative text-center">
    <Button
      v-if="!route.meta?.hideBackButton"
      variant="text"
      as="a"
      class="absolute left-0 px-0"
      @click.prevent="router.go(-1)"
    >
      <Icon name="ArrowLeft" size="lg" />
    </Button>
    <h1 class="text-lg text-secondary-700">{{ title }}</h1>
  </div>
</template>
